import React, {
  FC,
  useCallback,
}                   from 'react';
import {
  useField,
  FieldConfig,
  Field,
}                   from 'formik';
import {
  CheckboxProps,
  FormControlLabelProps,
}                   from '@material-ui/core';
import { Checkbox } from '@components/Checkbox/Checkbox';

type TCheckboxProps = CheckboxProps & Omit<FormControlLabelProps, 'control'>;
type TProps = FieldConfig & TCheckboxProps;

export const CheckboxField: FC<TProps> = ({ name, ...props }) => {
  const [field, , helpers] = useField<boolean>(name);

  const onChange = useCallback(
    (event: React.ChangeEvent<{}>, checked: boolean) => {
      helpers.setValue(checked);
    },
    [helpers],
  );

  return (
    <Field
      {...field}
      {...props}
      component = {Checkbox}
      checked   = {field.value}
      onChange  = {onChange}
    />
  );
};
